export   const getAllowedMimeTypes = (fileTypes) => {
  const allowedMimeTypes = fileTypes.map(fileType => fileType.code);
  return allowedMimeTypes;
};